// initial state
const state = {
  options: {
    status: {
      0: '已关闭',
      1: '已开启',
    },
    type: [
      {label: '批次配置', value: 1},
      {label: '项目配置', value: 0},
    ],
  },
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const midan = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/midan/midan.store.js